import React, { createContext } from "react"

const StoreContext = createContext()
const StoreConsumer = StoreContext.Consumer

const StoreProvider = ({ children, guideId, language }) => {
  return (
    <StoreContext.Provider value={{ guideId, language }}>
      {children}
    </StoreContext.Provider>
  )
}

export { StoreContext, StoreProvider, StoreConsumer }
